import { Box, Button, Typography } from '@mui/material';
import check from '../../assets/icons/check.svg';

interface LimitIndicatorProps {
  limit: number;
  hasLimit?: boolean;
  onConsult?: () => void;
}

const LimitIndicator = ({
  limit,
  hasLimit,
  onConsult,
}: LimitIndicatorProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column' },
        px: { xs: '14px', md: '52px' },
        pt: '20px',
        pb: { xs: '20px', md: '16px' },
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: { xs: 'column' },
          mb: { xs: '12px', md: '40px' },
          px: { xs: '20px', md: '150px', lg: '300px' },
          width: { lg: '1106px' },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'center',
            alignItems: 'center',
            gap: { xs: '0px', md: '20px' },
            mb: { md: '32px' },
          }}
        >
          <Box
            component="img"
            src={check}
            alt="Caution Icon"
            sx={{
              height: { xs: '88px', md: '104px' },
              width: { xs: '102px' },
              marginBottom: { xs: '24px', md: '0px' },
            }}
          />
          <Typography
            sx={{
              fontSize: { xs: '20px', md: '24px' },
              textAlign: { xs: 'center', md: 'left' },
              fontWeight: 700,
              color: '#00B906',
              fontFamily: 'Montserrat, sans-serif',
              marginBottom: { xs: '16px', md: '0px' },
            }}
          >
            Limite de Crédito Aprovado!
          </Typography>
        </Box>
        <Box
          sx={{
            backgroundColor: '#00B90626',
            border: '1px solid #00B906',
            borderRadius: '13px',
            padding: { xs: '14px', md: '24px' },
            width: '100%',
            marginBottom: '24px',
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: '14px' },
              textAlign: { xs: 'center' },
              fontWeight: 400,
              color: '#808080',
              fontFamily: 'Montserrat, sans-serif',
              marginBottom: '16px',
            }}
          >
            Seu limite aprovado:
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: '20px', md: '24px' },
              textAlign: { xs: 'center' },
              fontWeight: 700,
              color: '#00B906',
              fontFamily: 'Montserrat, sans-serif',
            }}
          >
            R${' '}
            {limit.toLocaleString('pt-BR', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Typography>
        </Box>
        {hasLimit && (
          <Box
            sx={{
              backgroundColor: '#FF950026',
              border: '1px solid #FF9500',
              borderRadius: '13px',
              padding: { xs: '12px', md: '24px' },
              width: '100%',
              marginBottom: '24px',
            }}
          >
            <Typography
              sx={{
                fontSize: { xs: '14px' },
                textAlign: { xs: 'center' },
                fontWeight: 700,
                color: '#808080',
                fontFamily: 'Montserrat, sans-serif',
                marginBottom: '8px',
                textTransform: 'uppercase',
              }}
            >
              ATENÇÃO
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '14px' },
                textAlign: { xs: 'center' },
                fontWeight: 400,
                color: '#808080',
                fontFamily: 'Montserrat, sans-serif',
              }}
            >
              Para este limite será necessário obrigatóriamente Carta de Crédito
              aceite por Carta de Nomeação durante o processo de contratação.
            </Typography>
          </Box>
        )}
        <Typography
          sx={{
            fontSize: { xs: '14px' },
            textAlign: 'center',
            fontWeight: 400,
            color: '#808080',
            fontFamily: 'Montserrat, sans-serif',
            marginBottom: { xs: '16px', md: '24px' },
          }}
        >
          {hasLimit
            ? 'Você possui limite aprovado, mas para continuar será necessário o aceite de uma Carta de Nomeação durante o processo de contratação.'
            : 'Excelente! Você está habilitado para contratar seguro garantia com condições especiais da nossa parceria.'}
        </Typography>
        <Typography
          sx={{
            fontSize: { xs: '14px' },
            textAlign: 'center',
            fontWeight: 400,
            color: '#808080',
            fontFamily: 'Montserrat, sans-serif',
          }}
        >
          {hasLimit
            ? 'Clique em "Faça aqui o orçamento" para prosseguir e preencher os dados complementares.'
            : 'Para continuar, preencha a seguir os dados complementares necessários para finalizar sua contratação.'}
        </Typography>
      </Box>
      <Box sx={{ px: { xs: '20px', md: '150px', lg: '300px' }, width: '100%' }}>
        <Button
          type="button"
          onClick={onConsult}
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontWeight: 700,
            fontSize: { xs: '12px', md: '14px' },
            color: '#FFF',
            background: '#004AA0',
            width: '100%',
            padding: '14px 0px',
            mb: { xs: '20px', md: '48px' },
            borderRadius: '4px',
            ':hover': { background: '#004ba0e7' },
          }}
        >
          Solicitar Cotação
        </Button>
      </Box>
      <Box
        sx={{
          borderTop: '1px solid #808080',
          width: '100%',
          pt: { xs: '12px', md: '16px' },
        }}
      >
        <Typography
          sx={{
            fontSize: { xs: '12px', md: '14px' },
            textAlign: 'center',
            fontWeight: 400,
            color: '#808080',
            fontFamily: 'Montserrat, sans-serif',
          }}
        >
          Processamento seguro | Parceria BBMNET + ASAS Garantias
        </Typography>
      </Box>
    </Box>
  );
};

export default LimitIndicator;
